import { Badge, List, Popover, Typography } from "antd";
import { BellOutlined } from "@ant-design/icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "../../i18n";
import { useTasksStats } from "./useTasksStats";
import { useTasksModelPath } from "./navigation";

// Bell with the three "needs attention" counters (tasks to do / overdue /
// unread comments), replacing the old header tags. Clicking a row navigates
// to the tasks model page.
export const NotificationBell: React.FC = () => {
  const t = useT();
  const navigate = useNavigate();
  const { stats, total } = useTasksStats(true);
  const tasksPath = useTasksModelPath();

  const content = (
    <List
      style={{ width: 280 }}
      size="small"
      dataSource={stats}
      locale={{ emptyText: t("notifications.empty") }}
      renderItem={(stat) => (
        <List.Item
          style={{ cursor: tasksPath ? "pointer" : "default" }}
          onClick={() => tasksPath && navigate(tasksPath)}
        >
          <Typography.Text style={{ fontSize: 13 }}>{stat.name}</Typography.Text>
          <Badge
            count={stat.count}
            showZero
            color={stat.count > 0 ? "#d1453b" : "#9a9a94"}
            style={{ marginLeft: "auto" }}
          />
        </List.Item>
      )}
    />
  );

  return (
    <Popover
      content={content}
      title={t("notifications.title")}
      trigger="click"
      placement="bottomRight"
    >
      <Badge count={total} size="small" offset={[-2, 2]}>
        <BellOutlined
          aria-label={t("notifications.title")}
          style={{ fontSize: 18, cursor: "pointer", padding: 6 }}
        />
      </Badge>
    </Popover>
  );
};
